'use strict';
// var net = require("./net")
var config = require("./config")
var helper = require("./helper")

var inCache = [];

var lcache = {
	addLocalStorage : function( key, content ) {
		try {
			localStorage.setItem( key, content );
			return true;
		} catch( e ) {
			console.log(e)
			return false;
			// if ( e.name.toUpperCase().indexOf('QUOTA') >= 0 ) {
			// 	var item;
			// 	var tempScripts = [];

			// 	for ( item in localStorage ) { //满了
			// 		if ( item.indexOf( storagePrefix ) === 0 ) {
			// 			tempScripts.push( JSON.parse( localStorage[ item ] ) );
			// 		}
			// 	}

			// 	if ( tempScripts.length ) {
			// 		// tempScripts.sort(function( a, b ) {
			// 		// 	return a.stamp - b.stamp;
			// 		// });

			// 		basket.remove( tempScripts[ 0 ].key );

			// 		return addLocalStorage( key, storeObj );

			// 	} else {
			// 		// no files to remove. Larger than available quota
			// 		return;
			// 	}

			// } else {
			// 	// some other error
			// 	return;
			// }
		}

	},
	getLocalStorage:function(key){
		try{
			var ret = localStorage.getItem( key );
			return ret
		}catch(e){
			console.log(e)
			return null
		}
		
	},
	save:function(key,content){
		// var now = +new Date();
		var ret=this.addLocalStorage(key,content)
		return ret

		// var dom = net.loadResource(url,function(newDom){
		// 	console.log(newDom)
		// })
		// var tag = getUrlTag(url)
		// dom.setAttribute("id",tag)
		// net.ajax({
		// 	url:url
		// })
	},
	load:function(key){
		var ret = this.getLocalStorage( key )
		return ret
	}
}

module.exports = lcache


//////////////////
// WEBPACK FOOTER
// ./src/lcache.js
// module id = 3
// module chunks = 0